import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface FanDetailsResponse {
  summary: any
  earnings: any
  subscription: any
}

interface FanDetailsCacheState {
  fanDetailsMap: Record<number, FanDetailsResponse>
  getFanDetailsById: (id: number) => FanDetailsResponse | undefined
  setFanDetailsCache: (id: number, data: FanDetailsResponse) => void
  clear: () => void

}

export const useFanDetailsCacheStore = create<FanDetailsCacheState>()(
  persist(
    (set, get) => ({
      fanDetailsMap: {},

      getFanDetailsById: (id) => get().fanDetailsMap[id],

      setFanDetailsCache: (id, data) => {
        set((state) => ({
          fanDetailsMap: {
            ...state.fanDetailsMap,
            [id]: data,
          },
        }))
      },
      clear: () => set({ fanDetailsMap: {} }) 
    }),
    {
      name: 'fan-details-cache',
      partialize: (state) => ({ fanDetailsMap: state.fanDetailsMap }),
    }
  )
)
